<template>
  <div class="position-relative">
    <div v-if="disabled" class="mask disabled zindex-3 rounded" />
    <gmap-map v-show="!loading"
              ref="gmap"
              class="gmap"
              :center="center"
              :zoom="zoom"
              :options="goolgeMapOptions"
              @zoom_changed="handleZoomChange"
    >
      <template v-if="!disabled">
        <gmap-info-window :options="infoOptions"
                          :position="infoWindowPos"
                          :opened="infoWinOpen"
                          @closeclick="closeInfoWindow"
        >
          <div v-if="currentItem" class="info-window-content">
            <div class="item__dateTime">
              <h2 class="m-0">{{ 'dateTimeLabel' | translate(labels) }}</h2>
              <span>{{ currentItem.startTs | formatDate }}</span><br>
              <span class="text-small">{{ currentItem.startTs | formatTime }}</span>
            </div>
            <div class="mt-2">
              <h2 class="m-0">{{ 'locationLabel' | translate(labels) }}</h2>
              <b-spinner v-if="currentItem.reversedGeolocation === true" variant="black" small class="mr-2" />
              <div v-else>
                {{ currentItem.reversedGeolocation }}
              </div>
              <div class="text-small">
                {{ currentItem.municipality }}
                {{ currentItem.subRegion }}
                {{ currentItem.region }}
                {{ currentItem.country }}
              </div>
            </div>
            <div class="mt-2 text-small">{{ currentItem.latitude }} {{ currentItem.longitude }}</div>
          </div>
        </gmap-info-window>

        <gmap-marker v-if="infoWinOpen"
                     :position="infoWindowPos"
                     :icon="itemNow.startTs === currentItem.startTs ? nowIconClicked : locationIconClicked"
                     :z-index="9999"
        />

        <gmap-marker v-for="(item, index) in items"
                     :key="'marker_' + index"
                     :position="{lat: item.latitude, lng: item.longitude}"
                     :clickable="true"
                     :icon="highlighted === item.startTs ? locationIconHighlighted : locationIcon"
                     :z-index="index"
                     @click="toggleInfoWindow(item)"
                     @mouseover="$emit('hover', item.startTs, true)"
                     @mouseout="$emit('hover', item.startTs, false)"
        />

        <gmap-marker v-if="itemNow && itemNow.latitude && itemNow.longitude"
                     :position="{lat: itemNow.latitude, lng: itemNow.longitude}"
                     :clickable="true"
                     :icon="nowHighlighted ? nowIconHighlighted : nowIcon"
                     :z-index="99999"
                     @click="toggleInfoWindow(itemNow)"
                     @mouseover="() => {$emit('hover', itemNow.startTs, true); nowHighlighted = true;}"
                     @mouseout="() => {$emit('hover', itemNow.startTs, false); nowHighlighted = false;}"
        />

        <gmap-polyline v-for="(arrow, i) in arrows"
                       :key="'arrow_' + i"
                       :path="arrow.path"
                       :options="arrow.options"
        />
      </template>
    </gmap-map>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import {geocodingService} from '@/services/google-maps-geocoding'

export default {
  props: {
    assetServer: {
      required: true
    },
    apiKey: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    highlighted: {
      required: true
    },
    arrowDir: {
      type: String,
      default: '-',
      validator(value) {
        return ['-', '+'].indexOf(value) !== -1
      },
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    itemNow: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      locationIcon: {
        path: 'M5 0C5 2.76 2.76 5 0 5C-2.76 5 -5 2.76 -5 0C-5 -2.76 -2.76 -5 0 -5C2.76 -5 5 -2.76 5 0Z',
        fillColor: '#333',
        fillOpacity: 1,
        strokeOpacity: 0
      },
      locationIconHighlighted: {
        path: 'M5 0C5 2.76 2.76 5 0 5C-2.76 5 -5 2.76 -5 0C-5 -2.76 -2.76 -5 0 -5C2.76 -5 5 -2.76 5 0Z',
        fillColor: '#333',
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#FFF'
      },
      locationIconClicked: {
        url: this.assetServer + '/assets/img/map/marker-black.svg',
        anchor: {x: 10, y: 35}
      },
      nowIcon: {
        path: 'M5 0C5 2.76 2.76 5 0 5C-2.76 5 -5 2.76 -5 0C-5 -2.76 -2.76 -5 0 -5C2.76 -5 5 -2.76 5 0Z',
        fillColor: '#ff3600',
        fillOpacity: 1,
        strokeOpacity: 0
      },
      nowIconHighlighted: {
        url: this.assetServer + '/assets/img/map/now-icon.svg',
        anchor: {x: 15, y: 15},
        scaledSize: {width: 29, height: 29}
      },
      nowIconClicked: {
        url: this.assetServer + '/assets/img/map/marker-red.svg',
        anchor: {x: 14, y: 50},
        scaledSize: {width: 29, height: 59}
      },
      nowHighlighted: false,
      isNowClicked: false,
      arrowOptions: {
        clickable: false,
        icons: [{
          icon: {
            path: 1,
            fillColor: '#333',
            fillOpacity: 1
          },
          offset: '100%'
        }],
        strokeColor: '#333',
        strokeOpacity: 1
      },
      arrows: [],
      google: null,
      center: {lat: 38, lng: -99},
      zoom: 4,
      loading: true,
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 140,
          height: 100
        }
      },
      currentItem: null,
      currentItemZIndex: 9999
    }
  },
  computed: {
    goolgeMapOptions() {
      return {
        streetViewControl: false,
        mapTypeControl: true,
        fullscreenControl: false,
        disableDoubleClickZoom: true,
        maxZoom: 22,
        mapTypeControlOptions: {
          position: this.google && this.google.maps.ControlPosition.LEFT_TOP,
          mapTypeIds: ['roadmap', 'satellite']
        },
        zoomControlOptions: {
          position: this.google && this.google.maps.ControlPosition.LEFT_BOTTOM
        },
        rotateControlOptions: {
          position: this.google && this.google.maps.ControlPosition.LEFT_CENTER
        },
        styles: [
          {
            featureType: 'poi.business',
            stylers: [{visibility: 'off'}]
          },
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{visibility: 'off'}]
          }
        ]
      }
    }
  },
  watch: {
    items(newItems) {
      this.fitToItems(newItems)
      this.generateArrows(newItems)
    }
  },
  beforeMount() {
    VueGoogleMaps.loadGmapApi({
      key: this.apiKey || '',
      libraries: 'drawing'
    })
  },
  async mounted() {
    await this.$refs.gmap.$mapPromise
    this.loading = false
    this.google = window.google
    this.fitToItems(this.items)
  },
  methods: {
    handleZoomChange(z) {
      if (this.zoom != z) {
        this.zoom = z
        this.generateArrows(this.items)
      }
    },
    closeInfoWindow() {
      this.infoWinOpen = false
      this.$emit('clicked', null)
    },
    async toggleInfoWindow(item) {
      this.infoWindowPos = {lat: item.latitude, lng: item.longitude}
      this.currentItem = item
      this.infoWinOpen = true
      this.$emit('clicked', item.startTs)
      if (!item.reversedGeolocation) {
        item.reversedGeolocation = true
        item.reversedGeolocation = await geocodingService.getNearestStreetAsString(item.latitude, item.longitude)
      }
    },
    async generateArrows(items) {
      if (!this.$refs.gmap && !this.google) return
      if (!items || !items.length) {
        this.arrows = []
        return
      }

      const arrows = []
      const map = await this.$refs.gmap.$mapPromise
      const offset = 10 // offset of the arrow in px

      let startLatLng = false
      let endLatLng = false
      for (let item of items) {
        if (item.latitude && item.longitude) {
          if (!startLatLng) {
            startLatLng = {lat: item.latitude, lng: item.longitude} //first point
          } else {
            endLatLng = {lat: item.latitude, lng: item.longitude}
            const startPoint = this.fromLatLngToPixel(new this.google.maps.LatLng(startLatLng.lat, startLatLng.lng), map)
            const endPoint = this.fromLatLngToPixel(new this.google.maps.LatLng(endLatLng.lat, endLatLng.lng), map)
            if (startPoint && endPoint) {
              const length = Math.round(Math.sqrt(Math.pow(Math.abs(startPoint.x - endPoint.x), 2) + Math.pow(Math.abs(startPoint.y - endPoint.y), 2)))

              if (length > 8 + (offset * 2)) { //line is at least 8 pixel long not including offset
                const ratio = offset / length
                const offsetStartPoint = {
                  x: Math.round((1 - ratio) * startPoint.x + ratio * endPoint.x),
                  y: Math.round((1 - ratio) * startPoint.y + ratio * endPoint.y)}
                const offsetEndPoint = {
                  x: Math.round((1 - ratio) * endPoint.x + ratio * startPoint.x),
                  y: Math.round((1 - ratio) * endPoint.y + ratio * startPoint.y)}

                arrows.push({
                  path: this.arrowDir === '-' ? [this.fromPixelToLatLng(offsetEndPoint, map), this.fromPixelToLatLng(offsetStartPoint, map)] : [this.fromPixelToLatLng(offsetStartPoint, map), this.fromPixelToLatLng(offsetEndPoint, map)],
                  options: this.arrowOptions
                })
              }
            }
            startLatLng = endLatLng
          }
        }
      }
      this.arrows = arrows
    },
    fromLatLngToPixel(position, map) {
      const scale = Math.pow(2, map.getZoom())
      const proj = map.getProjection()
      const bounds = map.getBounds()

      if (!proj) return

      const nw = proj.fromLatLngToPoint(
        new this.google.maps.LatLng(
          bounds.getNorthEast().lat(),
          bounds.getSouthWest().lng()
        ))
      const point = proj.fromLatLngToPoint(position)

      return {x: Math.floor((point.x - nw.x) * scale), y: Math.floor((point.y - nw.y) * scale)}
    },
    fromPixelToLatLng(pixel, map) {
      const scale = Math.pow(2, map.getZoom())
      const proj = map.getProjection()
      const bounds = map.getBounds()

      if (!proj) return

      const nw = proj.fromLatLngToPoint(
        new this.google.maps.LatLng(
          bounds.getNorthEast().lat(),
          bounds.getSouthWest().lng()
        ))

      return proj.fromPointToLatLng({x: pixel.x / scale + nw.x, y: pixel.y / scale + nw.y})
    },
    fitToItems: async function (items) {
      if (!this.$refs.gmap && !this.google) return

      const map = await this.$refs.gmap.$mapPromise
      const bounds = new this.google.maps.LatLngBounds()
      for (let item of items) {
        item.latitude && item.longitude && bounds.extend(new this.google.maps.LatLng(item.latitude, item.longitude))
      }
      map.fitBounds(bounds)
      if (this.zoom > 16) this.zoom = 16
    }
  }
}
</script>
